import { PixelRatio } from 'react-native';

const dpr = Math.max(PixelRatio.get(), 3).toString();

export function optimizeSanityImageUri(uri: string = '', imageHeight: number): string {
  const imageUri = new URL(uri);
  imageUri.searchParams.set('h', imageHeight.toString());
  imageUri.searchParams.set('dpr', dpr);
  imageUri.searchParams.set('fm', 'webp');

  return imageUri.toString();
}
